import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import type { ProgramCollaborator } from '../../api';

/** The program's creator + invited co-design admins, for the builder's avatars. */
export const useProgramCollaborators = (grpId: string | undefined) => {
  const [collaborators, setCollaborators] = useState<ProgramCollaborator[]>([]);

  const refresh = useCallback(async () => {
    if (!grpId) return;
    try {
      const data = await API.getProgramCollaborators(grpId);
      setCollaborators(Array.isArray(data?.collaborators) ? data.collaborators : []);
    } catch {
      // Avatars are decorative — never block the builder on them.
    }
  }, [grpId]);

  useEffect(() => {
    setCollaborators([]);
    refresh();
  }, [refresh]);

  return { collaborators, setCollaborators, refresh };
};
